import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { getRGBColor, getAccessibleColor, getVoteKey } from '@/utils';
import StatsApi from '@/stats-api';
import store from '@/store';

InertiaProgress.init()

createInertiaApp({
  resolve: name => import(`./pages/${name}`),
  setup({ el, App, props, plugin }) {
    const app = createApp({
      provide() {
        return {
          route: window.route,
          statsApi: this.statsApi
        }
      },

      data() {
        return {
          statsApi: new StatsApi(props.initialPage.props.faqIdentifier),
        }
      },

      watch: {
        '$page.props.settings': function(value) {
          if (! value) {
            return;
          }

          if (this.$page.props.settings) {
            this.setupPrimaryColor();
            this.loadCustomCss();

            if (this.$page.props.settings.user_feedback) {
              this.$store.dispatch('fetchVotes', this.statsApi);
            }
          }
        }
      },

      methods: {
        setupPrimaryColor() {
          const color = this.$page.props.settings.primary_color;

          const primaryColor = getRGBColor(color, 'primary');
          const a11yColor = getRGBColor(getAccessibleColor(color), 'a11y');

          const styleEl = document.createElement('style');
          styleEl.innerText = `:root {${primaryColor} ${a11yColor}}`;
          document.head.appendChild(styleEl);
        },

        loadCustomCss() {
          const css = this.$page.props.settings.css;

          if (! css) {
            return;
          }

          const styleEl = document.createElement('style');
          styleEl.textContent = css;
          document.head.appendChild(styleEl);
        }
      },

      render: () => h(App, props)
    });

    app.use(plugin)
       .use(store)
       .mount(el);
  },
})